module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ppelv16-eea7712ae0b66262112eeb70f4a4b9b6.jpg";